import { RolesService } from "@/common/api.service";
import { FETCH_ROLE_DATA, RESET_STATE } from "./actions.type";
import { SET_ROLE_DATA,  SET_ROLE_ERROR, STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    roledata: [],
    roleerror: [],
  }
};

export const state = initialState();

const actions ={

  async [FETCH_ROLE_DATA](context, slug) {
    return await RolesService.get(slug).then(response => {
      context.commit(SET_ROLE_DATA, response.data)
      return response
    }).catch(({ response }) =>{
      context.commit(SET_ROLE_ERROR, response.data.errorMessage)
      return response
    })
  },

  [RESET_STATE]({ commit }) {
    commit(STATE_RESET)
  }

}

const mutations = {

  [SET_ROLE_DATA](state, roledata) {
    state.roledata = roledata
  },
  [SET_ROLE_ERROR](state, error) {
    state.roleerror = error
  },  
  [STATE_RESET](state) {
    Object.assign(state,initialState())
  }

}

const getters = {
  
  roledata(state) {
    return state.roledata;
  },

}

export default {
    state,
    getters,
    actions,
    mutations
};